import { GET_ORDERS, GET_ORDER, GET_ORDER_ERR, GET_QR, GET_CHARGE_STATUS, POST_PAY_CREDIT, POST_PAY_CREDIT_ERR, POST_ORDER_STATUS, GET_ORDER_TOKEN } from './type';
// import {ROOT_URL} from '../../config';
// import {timeout} from '../common/index';//, loading
import { getErrorCode } from '../../assets/util';

export function getOrders(customer_no, doc_status = null, page, startDate) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: GET_ORDERS,
            payload: { data: [], count: 0 }
        });
        const params = {
            customer_no: customer_no,
            doc_status: doc_status,
            page: page - 1,
            startDate: startDate,
            sort: 'so_no',
            direction: 'desc',
            limit: 10,
            withItems: true
        }
        if (doc_status) {
            params.doc_status = doc_status
        }
        axios.get(`/orders`, {
            params
        })
            .then((response) => {
                dispatch({
                    type: GET_ORDERS,
                    payload: response.data
                });
            })
            .catch((error) => {
                // timeout(dispatch, error.code);
                dispatch({
                    type: GET_ORDERS,
                    payload: { data: [], count: 0 }
                });
            });
    }
}

export function getOrdersPromise(customer_no, doc_status, page, startDate) {

    return function (dispatch, getState, { axios }) {
        return new Promise((resolve, reject) => {
            dispatch({
                type: GET_ORDERS,
                payload: { data: [], count: 0 }
            });
            if (customer_no) {
                axios.get(`/orders`, {
                    params: {
                        customer_no: customer_no,
                        doc_status: doc_status,
                        page: page - 1,
                        startDate: startDate,
                        sort: 'so_no',
                        direction: 'desc',
                        limit: 10,
                    }
                })
                    .then((response) => {
                        dispatch({
                            type: GET_ORDERS,
                            payload: response.data
                        });
                        resolve();
                    })
                    .catch((error) => {
                        // timeout(dispatch, error.code);
                        dispatch({
                            type: GET_ORDERS,
                            payload: { data: [], count: 0 }
                        });
                        resolve();
                    });
            } else {
                resolve();
            }

        })
    }
}

export function getOrder(so_no, email = null) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: GET_ORDER,
            payload: null
        });
        dispatch({
            type: GET_CHARGE_STATUS,
            payload: false,
        })
        const params = { so_no };
        if (!getState().auth.authenticated && email) {
            localStorage.setItem('order_email', email);
            params.email = email;
        } else if (!getState().auth.authenticated) {
            params.email = localStorage.getItem('order_email');
        }
        axios.get(`/order`, {
            params,
        })
            .then((response) => {
                dispatch({
                    type: GET_ORDER,
                    payload: response.data[0]
                });
            })
            .catch((error) => {
                const err_code = getErrorCode(error);
                dispatch({
                    type: GET_ORDER_ERR,
                    payload: err_code
                });
            })
    }
}

export function getOrderToken(token) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: GET_ORDER_TOKEN,
            payload: null
        });

        axios.post(`/order/token`, {
            token,
        })
            .then((response) => {
                dispatch({
                    type: GET_ORDER_TOKEN,
                    payload: response.data[0]
                });
            })
            .catch((error) => {
                const err_code = getErrorCode(error);
                dispatch({
                    type: GET_ORDER_ERR,
                    payload: err_code
                });
            })
    }
}

export function clearOrder() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_ORDER,
            payload: null
        });
        dispatch({
            type: GET_ORDER_ERR,
            payload: null
        });
    }
}

export function getQR(so_no) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_QR,
            payload: { qr_image: null, expired: null, qr_id: null }
        });
        axios.get(`/order/qr`, {
            params: { so_no }
        })
            .then((response) => {
                const data = response.data;
                const { qr_image, expired, qr_id } = data;
                dispatch({
                    type: GET_QR,
                    payload: { qr_image, expired, qr_id }
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_QR,
                    payload: { qr_image: null, expired: null, qr_id: null }
                });
            })
    }
}

export function inquiryOrder(so_no) {
    return (dispatch, getState, { axios, axNL }) => {
        if (getState().cart.qrPaid !== null) {
            dispatch({
                type: GET_CHARGE_STATUS,
                payload: null
            });
            axNL.get(`/inquiry/charge`, {
                params: { so_no }
            })
                .then((response) => {
                    dispatch({
                        type: GET_CHARGE_STATUS,
                        payload: response.data
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: GET_CHARGE_STATUS,
                        payload: false
                    });
                })
        }
    }
}

export function payByCreditCard(so_no, card_token) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: POST_PAY_CREDIT,
            payload: null
        })
        axios.post(`/payment_credit`, {
            so_no, card_token
        })
            .then((response) => {
                dispatch({
                    type: 'LOADING',
                    payload: true
                });
                if (response.data.response_code === "00") {
                    dispatch({
                        type: 'LOADING',
                        payload: false
                    });
                }
                dispatch({
                    type: POST_PAY_CREDIT,
                    payload: response.data.response_code === "00",
                    authen_url: response.data.authen_url,
                })
            })
            .catch((error) => {
                dispatch({
                    type: POST_PAY_CREDIT_ERR,
                    payload: error.response?.data || error.message,
                })
            })
    }
}

export function setOrderComplete(so_no, complete = true, review_complete = false) {
    return (dispatch, getState, { axios }) => {
        // console.log ("Set order complete", so_no)
        dispatch({
            type: POST_ORDER_STATUS,
            payload: null
        })
        axios.post(`/order/status`, {
            so_no, new_status: 98 + (review_complete ? 1 : 0)
        })
            .then((response) => {
                dispatch({
                    type: POST_ORDER_STATUS,
                    payload: true
                })
            })
        // let status;
        // if (complete) {
        //     status = 98
        // }
        // if (review_complete) {
        //     status = 99
        // }
        // dispatch({
        //     type: POST_ORDER_STATUS,
        //     payload: null
        // })
        // axios.post(`/order/status`, {
        //     so_no,
        //     new_status: (complete && review_complete)? 99: 98,
        // })
        // .then((response) => {
        //     dispatch({
        //         type: POST_ORDER_STATUS,
        //         payload: response.data
        //     })
        // })
        // .catch((error) => {
        //     dispatch({
        //         type: POST_ORDER_STATUS_ERR,
        //         payload: error.response.data,
        //     })
        // })
    }
}